<template>
  <v-container>

    <!-- aldeci   {{ filtrosRecebidos }}   -->

    <!-- Diálogo de Carregamento -->
    <v-dialog v-model="loadingDialog" persistent max-width="300">
      <v-card>
        <v-card-text class="text-center">
          <v-progress-circular indeterminate color="green"></v-progress-circular>
          <p>{{ mensagemDialog }}</p>
    </v-card-text>
      </v-card>

      
    </v-dialog>



    <v-card>

      <!-- Toolbar -->
      <v-toolbar color="primary" dark>
        <v-toolbar-title>Quadro de Funcionários</v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="voltaraomenu">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider></v-divider>

      <!-- Botão para Exibir/Ocultar Filtros -->
      <v-row justify="end" class="pa-4">
        <v-btn color="primary" @click="toggleFiltros">
          <v-icon left>{{ mostrarFiltros ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
          {{ mostrarFiltros ? 'Ocultar Filtros' : 'Exibir Filtros' }}
        </v-btn>
      </v-row>

      <!-- Filtros -->
      <v-expand-transition>
        <div v-if="mostrarFiltros">
          <v-row class="pa-4">
            <v-col cols="4">
              <v-select v-model="filtros.funcionario" :items="funcionariosNomes" label="Filtrar por Funcionário" dense
                outlined />
            </v-col>
            <v-col cols="4">
              <v-select v-model="filtros.ordem" :items="ordens" label="Filtrar por Ordem" dense outlined />
            </v-col>
            <v-col cols="4">
              <v-select v-model="filtros.modelos" :items="modelos" label="Filtrar por Modelos" multiple dense
                outlined />
            </v-col>
            <v-col cols="4">
              <v-select v-model="filtros.clientes" :items="clientes" label="Filtrar por Clientes" multiple dense
                outlined />
            </v-col>
            <v-col cols="4">
              <v-text-field v-model="filtros.dataAberturaInicial" label="Data Abertura Inicial" dense outlined clearable
                type="date" @input="validarData('dataAberturaInicial')" />
            </v-col>
            <v-col cols="4">
              <v-text-field v-model="filtros.dataAberturaFinal" label="Data Abertura Final" dense outlined clearable
                type="date" @input="validarData('dataAberturaFinal')" />
            </v-col>
            <v-col cols="4">
              <v-select v-model="filtros.setores" :items="setores" label="Filtrar por Setor" multiple dense outlined />
            </v-col>
            <v-col cols="4">
              <v-select v-model="filtros.chiefes" :items="chiefes" label="Filtrar por Chefe" multiple dense outlined />
            </v-col>
          </v-row>

          <!-- Botões de ação -->
          <v-row justify="end" class="px-4">
            <v-btn color="primary" class="mr-3" @click="aplicarFiltro">
              <v-icon left>mdi-filter</v-icon> Filtrar
            </v-btn>
            <v-btn color="error" @click="limparFiltro">
              <v-icon left>mdi-broom</v-icon> Limpar Filtros
            </v-btn>
          </v-row>
        </div>
      </v-expand-transition>

      <!-- Tabela -->
         <v-data-table :headers="headers" :items="filtrarFuncionarios()" item-key="id" dense class="elevation-1">

        <template #item.acao="{ item }">
          <v-btn color="primary" @click="mostrarDetalhes(item)">
            Mostrar
          </v-btn>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="dialogAtivo" fullscreen persistent>
      <v-card>
        <v-toolbar color="primary" dark>
          <v-toolbar-title>Detalhes do Funcionário</v-toolbar-title>
          <v-spacer />
          <v-btn icon @click="dialogAtivo = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="mb-5">
          <v-row class="gradient-row dense">
            <v-col cols="6">
              <h3>Funcionário</h3> <!-- Linha adicionada/alterada: Título fixo -->
            </v-col>
            <v-col cols="2">
              <strong>Tempo Total</strong> <!-- Linha adicionada/alterada -->
            </v-col>
            <v-col cols="2">
              <strong>Tempo Útil</strong> <!-- Linha adicionada/alterada -->
            </v-col>
            <v-col cols="2">
              <strong>Tempo Não Útil</strong> <!-- Linha adicionada/alterada -->
            </v-col>
          </v-row>

          <v-divider class="mt-2 mb-2"></v-divider>
          <!-- Linha adicionada/alterada: segunda row (valores) -->
          <v-row class="gradient-row dense">
            <v-col cols="6">
              <h3>{{ funcionarioSelecionado?.nome }}</h3> <!-- Agora mostra o nome real -->
            </v-col>
            <v-col cols="2">
              <h3> {{ funcionarioSelecionado?.tempoTotal }} </h3>
            </v-col>
            <v-col cols="2">
              <h3> {{ funcionarioSelecionado?.tempoUtil }}</h3>
            </v-col>
            <v-col cols="2">
              <h3>{{ funcionarioSelecionado?.tempoNaoUtil }}</h3>
            </v-col>
          </v-row>
          <v-divider class="mt-3 mb-4"></v-divider>
          <div v-for="ordem in funcionarioSelecionado?.ordens" :key="ordem.id_ordem" class="mb-4">

            <!-- Linha alterada: agora utilizamos <v-col> para cada pedaço de informação -->
            <v-row class="gradient-ordem-row dense mt-3 mb-3  ">
              <v-col cols="2">
                <h4>ID Lanc: {{ ordem.id_ordem }}</h4> <!-- Linha adicionada/alterada -->
              </v-col>
              <v-col cols="3">
                <h4>Ordem Número: {{ ordem.numero_ordem }}</h4> <!-- Linha adicionada/alterada -->
              </v-col>
              <v-col cols="3">
                <h4>Pedido: {{ ordem.numero_pedido }}</h4> <!-- Linha adicionada/alterada -->
              </v-col>
              <v-col cols="3">
                <h4>Modelo: {{ ordem.modelo }}</h4> <!-- Linha adicionada/alterada -->
              </v-col>
              <v-col cols="1">
                <h4><strong>Status:</strong> {{ ordem.id_ordem_status }}</h4> <!-- Linha adicionada/alterada -->
              </v-col>
            </v-row>


            <v-data-table :headers="subHeaders" :items="ordem.intervalos_consolidados" dense :items-per-page="-1">
              <template #bottom></template>

              <template #top>
                <!-- <div class="text-h6 font-weight-medium">Intervalos</div> -->
              </template>
              <template #item.inicio="{ item }">
                {{ formatarData(item.inicio) }}
              </template>
              <template #item.fim="{ item }">
                {{ formatarData(item.fim) }}
              </template>
              <!-- Template para remover o footer -->
              <template #footer>
                <div></div>
              </template>
            </v-data-table>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>



  </v-container>
</template>

<script>
import { aberturaExpedienteService } from "@/services/aberturaExpedienteService";

export default {


  data() {
    return {
      mostrarFiltros: false, // Inicia com os filtros ocultos

      filtros: {
        funcionario: null,
        ordem: null,
        modelos: [],
        clientes: [],
        dataAberturaInicial: null,
        dataAberturaFinal: null,
        setores: [],
        chiefes: [],
      },
      funcionarios: [],
      funcionariosNomes: [],
      ordens: [],
      modelos: [],
      clientes: [],
      setores: [],
      chiefes: [],
      dialogAtivo: false,
      loadingDialog: false,
      mensagemDialog: "Carregando dados...",
      funcionarioSelecionado: null,

      headers: [
        { title: "Funcionário", key: "nome" },
        { title: "Tempo Total", key: "tempoTotal" },
        { title: "Tempo Útil", key: "tempoUtil" },
        { title: "Tempo Não Útil", key: "tempoNaoUtil" },
        { title: "Ação", key: "acao", sortable: false },
      ],
      subHeaders: [
        { title: "Início", key: "inicio" },
        { title: "Fim", key: "fim" },
        { title: "Descrição Início", key: "descricao_status_inicio" },
        { title: "Descrição Fim", key: "descricao_status_fim" },
        { title: "Tempo", key: "tempo_intervalo" },
        { title: "Horas Trabalhadas", key: "horas_trabalhadas" },
      ],
    };
  },
  methods: {
    toggleFiltros() {
      this.mostrarFiltros = !this.mostrarFiltros;
    },


    validarData(data) {

      // Validação de data  yyyy-mm-dd nesse formato
      const regexData = /^\d{4}-\d{2}-\d{2}$/;
      if (!regexData.test(this.filtros[data])) {
        this.filtros[data] = null;
        this.$refs.snackbar.show("Data inválida. Utilize o formato 'yyyy-mm-dd'.");
      }

    },

    aplicarFiltro() {
      // Cria uma cópia dos filtros ajustando o campo `ordem` para `id_ordem` como inteiro
      const filtrosParaAPI = {
        ...this.filtros,
        id_ordem: this.filtros.ordem ? parseInt(this.filtros.ordem, 10) : null, // Converte para inteiro ou null
      };


      delete filtrosParaAPI.ordem; // Remove o campo `ordem` original

      // Envia os filtros ajustados para a API
      this.fetchData(filtrosParaAPI);
    },

    limparFiltro() {
      this.filtros = {
        funcionario: null,
        ordem: null,
        modelos: [],
        clientes: [],
        dataAberturaInicial: null,
        dataAberturaFinal: null,
        setores: [],
        chiefes: [],
      };
      this.fetchData(); // Recarrega os dados sem filtros
    },

    voltaraomenu() {
      this.$router.push({ name: "AberturaExpedienteMenuMobile" }).catch(() => { });

    },
    async fetchData(filtros = {}) {
      try {
        this.loadingDialog = true;

        // Verifica e renomeia a propriedade se existir
        if (filtros.dataAberturaInicial) {
          filtros.data_abertura = filtros.dataAberturaInicial;
          delete filtros.dataAberturaInicial;
        }

        // alert("filtros: " + JSON.stringify(filtros));

        const response = await aberturaExpedienteService.consultaQuadro(filtros);

        if (response.success) {
          const funcionariosProcessados = response.dados.map(funcionario => {
            const ordens = funcionario.ordens.map(ordem => ({
              id_ordem: ordem.id_ordem,
              modelo: ordem.modelo,
              cliente: ordem.cliente,
              // 20-01-2025
              numero_pedido: ordem.numero_pedido,
              numero_ordem: ordem.numero_ordem,
              id_ordem_status: ordem.id_ordem_status,
              data_abertura: ordem.data_abertura,
              abertura_setor: ordem.abertura_setor?.descricao_setor,
              abertura_chefe: ordem.abertura_chefe?.nome,
              intervalos_consolidados: ordem.intervalos_consolidados,
            }));

            return {
              id: funcionario.id_funcionario,
              nome: funcionario.nome_funcionario,
              tempoTotal: funcionario.tempo_total_funcionario,
              tempoUtil: funcionario.tempo_util_funcionario,
              tempoNaoUtil: funcionario.tempo_nao_util_funcionario,
              ordens,
            };
          });

          this.funcionarios = funcionariosProcessados;

          this.funcionariosNomes = [...new Set(funcionariosProcessados.map(f => f.nome))];
          this.ordens = [...new Set(funcionariosProcessados.flatMap(f => f.ordens.map(o => o.id_ordem)))];
          this.modelos = [...new Set(funcionariosProcessados.flatMap(f => f.ordens.map(o => o.modelo)))];
          this.clientes = [...new Set(funcionariosProcessados.flatMap(f => f.ordens.map(o => o.cliente)))];
          this.setores = [...new Set(funcionariosProcessados.flatMap(f => f.ordens.map(o => o.abertura_setor)))];
          this.chiefes = [...new Set(funcionariosProcessados.flatMap(f => f.ordens.map(o => o.abertura_chefe)))];

          this.loadingDialog = false;
        } else {
          this.loadingDialog = false;
          console.error("Erro ao carregar dados:", response.message);
        }
      } catch (error) {
        this.loadingDialog = false;
        console.error("Erro ao buscar dados:", error);
      }
    }

    ,


    filtrarFuncionarios() {
      return this.funcionarios.filter(funcionario => {
        const matchFuncionario = !this.filtros.funcionario || funcionario.nome === this.filtros.funcionario;
        const matchOrdem = !this.filtros.ordem || funcionario.ordens.some(ordem => ordem.id_ordem === this.filtros.ordem);
        const matchModelo = !this.filtros.modelos.length || funcionario.ordens.some(ordem => this.filtros.modelos.includes(ordem.modelo));
        const matchCliente = !this.filtros.clientes.length || funcionario.ordens.some(ordem => this.filtros.clientes.includes(ordem.cliente));
        const matchSetor = !this.filtros.setores.length || funcionario.ordens.some(ordem => this.filtros.setores.includes(ordem.abertura_setor));
        const matchChefe = !this.filtros.chiefes.length || funcionario.ordens.some(ordem => this.filtros.chiefes.includes(ordem.abertura_chefe));
        const matchDataInicial = !this.filtros.dataAberturaInicial || funcionario.ordens.some(ordem => new Date(ordem.data_abertura) >= new Date(this.filtros.dataAberturaInicial));
        const matchDataFinal = !this.filtros.dataAberturaFinal || funcionario.ordens.some(ordem => new Date(ordem.data_abertura) <= new Date(this.filtros.dataAberturaFinal));

        return matchFuncionario && matchOrdem && matchModelo && matchCliente && matchSetor && matchChefe && matchDataInicial && matchDataFinal;
      });
    },


    mostrarDetalhes(funcionario) {
      this.funcionarioSelecionado = funcionario;
      this.dialogAtivo = true;
    },

    formatarData(dataIso) {
      const data = new Date(dataIso);
      return data.toLocaleString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });
    },
  },
  created() {

    const { filtros } = this.$route.query;

    if (filtros) {
      try {
        this.filtrosRecebidos = JSON.parse(filtros);
      } catch (error) {
        console.error("Erro ao converter filtros de query:", error);
      }
    }

    // Exemplo: se seu service aceitar "id_setor" e "data_abertura", pegue do array:
    if (this.filtrosRecebidos.length > 0) {
      const { id_setor, data_abertura, id_abertura } = this.filtrosRecebidos[0];
      // Agora você pode chamar seu service usando esses valores
      console.log("Recebemos id_setor:", id_setor, "data_abertura:", data_abertura, "id_abertura:", id_abertura);

      // Chame seu service passando esses parâmetros, ex:
      // aberturaExpedienteService.consultaQuadro({ id_setor, data_abertura })
      //   .then(...)
      //   .catch(...)
      this.fetchData({ id_abertura });
      return;
    }

    this.fetchData();

  },
};
</script>

<style scoped>
.gradient-row {
  background: linear-gradient(to right, #f0f0f0, #d3d3d3);
  /* Ajuste conforme desejado */
}

.gradient-ordem-row {
  background: linear-gradient(to right, #82a2c1, #bcc2cb);

}


/* Estilos opciona  is */
</style>
